import { Component, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { LabTestResult } from '../../lab-test-results';
import { LabTestResultGridRowItem } from '../grid-row-item';
import { MdlDialogService } from '@angular-mdl/core';

@Component({
    selector: 'test-title-cell',
    template: require('./test-title-ag-renderer.component.html'),
    styles: [require('./test-title-ag-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestTitleAgRendererComponent implements AgRendererComponent {

    public title = '';
    public isOptional = false;
    public isQuestion = false;

    constructor(private dialogService: MdlDialogService) {
    }

    public refresh() {
        return false;
    }

    public agInit(row: LabTestResultGridRowItem): void {
        if (row.node.group) {
            return;
        }
        this.title = row.data.test;
        this.isOptional = row.data.isOptional;
        this.isQuestion = row.data.isQuestion;
    }

    public onQuestionMouseOver(event: MouseEvent) {
        // Don't show covance-tooltip together with Admin Question tooltip.
        event.stopPropagation();
    }
}